import React, { useEffect, useState } from "react";
import { Navbar, Dropdown } from "react-bootstrap";
import { BsListNested } from "react-icons/bs";
import { CiBellOn } from "react-icons/ci";
import { IoLogOutOutline } from "react-icons/io5";
import { PiUserCircle } from "react-icons/pi";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logout } from "../../store/slices/auth";
import { getProfile } from "../../store/slices/auth";
import { setActiveStudent } from "../../store/slices/activestudent";
import { useSelector } from "react-redux";
import { BsCheckCircleFill } from "react-icons/bs";

export default function HeaderNav({ mobileMenuclick }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const activeStudent = useSelector(
    (state) => state.activestudent?.student
  );

  const [students, setStudents] = useState([]);

  useEffect(() => {
    dispatch(getProfile())
      .unwrap()
      .then((res) => {
        console.log("GET PROFILE RESULT:", res);

        const children =
          res?.data?.studentDetails ||
          res?.studentDetails ||
          [];

        console.log("STUDENTS:", children);

        setStudents(children);

        const savedStudent = JSON.parse(
          localStorage.getItem("activeStudent")
        );

        if (savedStudent) {
          const exists = children.find(
            (c) => c._id === savedStudent._id
          );

          if (exists) {
            dispatch(setActiveStudent(exists));

            localStorage.setItem("activeStudent", JSON.stringify(exists));
            if (exists.standardId) {
              localStorage.setItem(
                "activeStandard",
                JSON.stringify(exists.standardId)
              );
            }
            return;
          }
        }

        if (children.length > 0) {
          dispatch(setActiveStudent(children[0]));
          localStorage.setItem("activeStudent", JSON.stringify(children[0]));
          if (children[0].standardId) {
            localStorage.setItem(
              "activeStandard",
              JSON.stringify(children[0].standardId)
            );
          }
        }
      })
      .catch(() => {
        console.error("Failed to load profile");
      });
  }, [dispatch]);


  const handleSelectStudent = (student) => {
    localStorage.setItem("activeStudent", JSON.stringify(student));
    if (student.standardId) {
      localStorage.setItem("activeStandard", JSON.stringify(student.standardId));
    }
    dispatch(setActiveStudent(student));
  };

  const handleLogout = async () => {
    try {
      const resultAction = await dispatch(logout());
      if (logout.fulfilled.match(resultAction)) {
        navigate("/login", { replace: true });
      }
    } catch (err) {
      console.error("Logout error:", err);
    }
  };


  const getInitials = (name = "") =>
    name
      .trim()
      .split(" ")
      .filter(Boolean)
      .slice(0, 2)
      .map((n) => n[0]?.toUpperCase())
      .join("");


  const renderAvatar = (student, size = 22, ringColor) => {
    const img = student?.profileImage || student?.avatar || student?.photo;

    const baseStyle = {
      width: size,
      height: size,
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: size * 0.42,
      fontWeight: 600,
      color: "#fff",
      background: "#8451ff",
      overflow: "hidden",
      flexShrink: 0,
      border: ringColor ? `2px solid ${ringColor}` : "2px solid transparent",
      boxSizing: "content-box",
    };

    if (img) {
      return (
        <div style={baseStyle}>
          <img
            src={img}
            alt={student?.name || "student"}
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
          />
        </div>
      );
    }

    return <div style={baseStyle}>{getInitials(student?.name) || "?"}</div>;
  };


  const styleIcons = {

    width: "43px",
    height: "43px",
    borderRadius: "14px",
    border: "1px solid rgba(132, 81, 255, 0.25)",
    background: "rgba(132, 81, 255, 0.12)",
    backdropFilter: "blur(12px)",
    WebkitBackdropFilter: "blur(12px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#8451ff",
    boxShadow:
      "0 8px 24px rgba(132, 81, 255, 0.18), inset 0 1px 0 rgba(255,255,255,0.35)",
    transition: "all 0.3s ease",
    cursor: "pointer",

  }


  return (
    <Navbar bg="white" className="top-header shadow-sm px-4">
      <div className="header-inner d-flex align-items-center w-100">
        <button className="hamburger-btn" onClick={mobileMenuclick}>
          <BsListNested />
        </button>
        <div className="welcome-text ms-3">
          <span>WELCOME!</span>
          {activeStudent && (
            <div
              style={{
                fontSize: "12px",
                color: "#6b7280",
                fontWeight: 500,
                marginTop: "2px",
              }}
            >
              {activeStudent.name}
              {activeStudent.standardId?.name
                ? ` • ${activeStudent.standardId.name}`
                : ""}
            </div>
          )}
        </div>

        <div className="header-actions d-flex align-items-center ms-auto">

          <Dropdown align="end">
            <Dropdown.Toggle
              as="div"
              className="icon-btn dropdown-toggle-custom"
              title="Switch Account"
              style={{
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {activeStudent ? (
                renderAvatar(activeStudent, 22, "#8451ff")
              ) : (
                <PiUserCircle style={{ fontSize: "20px" }} />
              )}
            </Dropdown.Toggle>

            <Dropdown.Menu
              style={{
                minWidth: "260px",
                border: "3px solid #a88af7",
                borderRadius: "16px",
                background: "#fff",
                padding: "8px",
                boxShadow: "0 12px 30px rgba(15, 130, 210, 0.12)",
                overflow: "hidden",
              }}
            >
              <Dropdown.Header className="fw-bold">
                Switch Student
              </Dropdown.Header>

              {students.length === 0 && (
                <Dropdown.Item disabled>No students</Dropdown.Item>
              )}

              {students.map((s) => {
                const isActive = activeStudent?._id === s._id;

                return (
                  <Dropdown.Item
                    key={s._id}
                    onClick={() => handleSelectStudent(s)}
                    className={`d-flex align-items-center justify-content-between ${isActive ? "bg-light fw-bold" : ""
                      }`}
                    style={{
                      borderLeft: isActive
                        ? "4px solid #8451ff"
                        : "4px solid transparent",
                    }}
                  >
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      {renderAvatar(
                        s,
                        26,
                        isActive ? "#22c55e" : "transparent"
                      )}
                      <span>
                        {s.name}
                        {s.standardId?.name && (
                          <div
                            style={{
                              fontSize: "11px",
                              color: "#9ca3af",
                              fontWeight: 400,
                            }}
                          >
                            {s.standardId.name}
                          </div>
                        )}
                      </span>
                    </span>

                    {isActive && (
                      <BsCheckCircleFill
                        style={{ color: "#22c55e", fontSize: "14px" }}
                      />
                    )}
                  </Dropdown.Item>
                );
              })}
            </Dropdown.Menu>
          </Dropdown>
          <button
            className="icon-btn notification-btn"
            style={styleIcons}
          >
            <CiBellOn style={{ fontSize: "24px" }} />
            <span
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                width: "9px",
                height: "9px",
                borderRadius: "50%",
                background: "#ff4d6d",
                border: "2px solid #fff",
                boxShadow: "0 0 10px rgba(255,77,109,.6)",
              }}
            />
          </button>


          <Dropdown align="end">
            <Dropdown.Toggle
              as="div"
              className="icon-btn dropdown-toggle-custom" style={styleIcons}
            >
              <PiUserCircle style={{ fontSize: "22px" }} />
            </Dropdown.Toggle>

            <Dropdown.Menu style={{
              minWidth: "220px",
              border: "3px solid #a88af7",
              borderRadius: "16px",
              background: "#fff",
              padding: "8px",
              boxShadow: "0 12px 30px rgba(15, 130, 210, 0.12)",
              overflow: "hidden",
            }}>

              <Dropdown.Item onClick={() => navigate('/student/profile')}>Profile</Dropdown.Item>
              <Dropdown.Divider />
              <Dropdown.Item className="text-danger" onClick={handleLogout}>
                <IoLogOutOutline style={{ marginRight: "6px" }} />
                Logout
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>
    </Navbar>
  );
}